<!-- <div class="dialog-padding"> -->
<div class="custom-model-header">
    <h1>Set document expiry date
        <button class="cancel-button" (click)="closeOnClick()">&times;</button>
    </h1>
    
</div>
<mat-dialog-content class="custom-dialog-content dialog-padding">
    <p>The uploaded document will be deleted from blob storage on the chosen date</p>
    <div class="file-name-holder">
        <span class="uploaded-document-title">Uploaded document</span>
        <span class="selected-file-name"> {{selectedFileName}} <img src="../../../assets/images/pdf-icon.png" alt="" /></span>
    </div>
    <form [formGroup]="docExpiryForm" class="doc-exp-form">
        <div class="row">
            <div class="col-6">
                <div class="Info">
                    <span class="custom-label">Set expiry date</span>
                    <mat-select class="SelectD" formControlName="expType"
                        (selectionChange)="selectFileExt($event.value)" placeholder="Expiry option">
                        @for (date of availableDates; track date.label) {
                        <mat-option [value]="date">{{date.label}}</mat-option>
                        }
                    </mat-select>
                </div>
            </div>
            <div class="col-6">
                <div class="Info expiry-date-calender">
                    <span class="custom-label">Set expiry date</span>
                    <input matInput [matDatepicker]="expiryPicker" formControlName="expDate" placeholder="Expiry date"
                        (dateChange)="expiryDate($event)" [min]="yesterday">
                    <mat-datepicker-toggle matSuffix [for]="expiryPicker"></mat-datepicker-toggle>
                    <mat-datepicker #expiryPicker></mat-datepicker>
                </div>
            </div>
        </div>
    </form>
    
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions dialog-padding">
    <button mat-button (click)="submit()" class="submit-btn">Submit</button>
</mat-dialog-actions>
<!-- </div> -->